import { number, object, string } from 'yup';

export default object().shape({
  id_transportadora: number().required('Este campo é obrigatório!'),
  placa: string().required('Este campo é obrigatório!')
})